import { Box, Button, Header, Hotspot, Modal, SpaceBetween } from '@amzn/awsui-components-react';
import React, { Component } from 'react';

import { constants } from '../../../common/Localization';
import { getIndexedId, HotspotIds } from '../../tutorials/HotspotIds';
import { WIZARD_STEP_VALUES } from './common-util/resources';
import { WizardStepsMap } from './common-util/types';

interface Props {
    currentStep: WIZARD_STEP_VALUES;
    steps: WizardStepsMap;
    loading: boolean;
    cancel: () => void;
    prev: () => void;
    next: () => void;
}

interface State {
    visible: boolean;
}

class WizardActionButtons extends Component<Props, State> {
    state = {
        visible: false,
    };

    showCancelFrictionModal = (): void => {
        this.setState({
            visible: true,
        });
    };

    hideCancelFrictionModal = (): void => {
        this.setState({
            visible: false,
        });
    };

    render() {
        const { cancel, currentStep, loading, next, prev, steps } = this.props;
        const { visible } = this.state;
        if (!currentStep) {
            return null;
        }
        const currentStepIndex = Object.keys(steps).findIndex(step => step === currentStep);
        const isLastStep = currentStepIndex === Object.keys(steps).length - 1;
        const isFirstStep = currentStepIndex === 0;
        const footer = (
            <Box float='right'>
                <SpaceBetween direction='horizontal' size='s'>
                    <Button variant='link' onClick={this.hideCancelFrictionModal}>{constants.CANCEL_BUTTON}</Button>
                    <Button variant='primary' onClick={cancel}>{constants.CONTINUE_BUTTON}</Button>
                </SpaceBetween>
            </Box>
        );
        return (
            <div>
                <Header actions={
                    <SpaceBetween direction='horizontal' size='m'>
                        <Button variant='link' onClick={this.showCancelFrictionModal} id='cancelBtn'>{constants.CANCEL_BUTTON}</Button>
                        {isFirstStep ? null : <Button onClick={prev} disabled={loading}>{constants.PREVIOUS_BUTTON}</Button>}
                        <Hotspot hotspotId={getIndexedId(HotspotIds.WIZARD_NEXT_BUTTON, currentStepIndex)} side='right' direction='top'>
                            <Button variant='primary' onClick={next} disabled={loading} id='nextBtn'>
                                {isLastStep ? constants.CONFIRM_IMPORT_BUTTON : constants.NEXT_BUTTON}
                            </Button>
                        </Hotspot>
                    </SpaceBetween>
                } />
                <Modal
                    visible={visible}
                    header={constants.WIZARD_CANCEL_FRICTION_MODAL_TITLE}
                    footer={footer}
                    onDismiss={this.hideCancelFrictionModal}
                >
                    {constants.WIZARD_CANCEL_FRICTION_MODAL_CONTENT}
                </Modal>
            </div>
        );
    }
}

export default WizardActionButtons;
